import { Tag } from '@design-system/components/tag/tag';
import { Typography } from '@design-system/components/typography/typography';
import { clsx } from 'clsx';
import { sprinkles } from '@design-system/sprinkles.css';
import { Video } from '../../models/videos.domain';
import { Row } from '@design-system/components/grid/grid';
import { Chip } from '@design-system/components/chip/chip';
import { Badge } from '@design-system/components/badge';

export type VideoListItem = {
  id: string;
  imageUrl: string;
  title: string;
  duration: string;
  tag: {
    label: string;
  };
  date: string;
  onClick: (v: Video) => void;
  tags?: string[];
  selectedIndx?: number;
};

const toTagName = (tag: string) => {
  switch (tag) {
    case 'extras-video':
      return 'Extras video';
    default:
      return tag;
  }
};

export const LibraryListItem = ({
  imageUrl,
  title,
  duration,
  tag,
  date,
  selected,
  id,
  selectVideo,
  selectedIndx,
  tags,
}: VideoListItem & {
  selected: boolean;
  selectVideo: (id: string) => void;
}) => {
  const selectionIndex =
    selectedIndx !== undefined && selectedIndx > -1 ? selectedIndx + 1 : null;
  return (
    <div
      className={clsx(
        'flex items-center gap-6 rounded-[10px]',
        selected && sprinkles({ bg: 'N-10' }),
        !selected && sprinkles({ bg: 'W-100' }),
      )}
      onClick={() => selectVideo(id)}
    >
      <div className="flex flex-row">
        <div className="mr-4 w-[68px] h-[68px] p-2 flex justify-center items-center">
          <img
            src={imageUrl}
            className={clsx(
              sprinkles({ clipPath: 'sm' }),
              'max-w-[52px] max-h-[52px]',
            )}
          />
        </div>
        <div className="flex flex-col justify-center">
          <div className="w-[200px] md:w-[340px]">
            <Typography
              variant="body"
              size="large"
              color="N-100"
              className="truncate"
            >
              {title}
            </Typography>
          </div>
          <div>
            <Row alignCenter>
              <Typography variant="body" size="medium" color="N-60">
                {duration}
              </Typography>
              <Typography variant="body" size="medium" color="N-60">
                {tags && tags.length > 0 ? '•' : ''}
              </Typography>

              {tags?.map((tag) => (
                <Badge label={toTagName(tag)} key={tag} />
              ))}
            </Row>
          </div>
        </div>
      </div>
      <div className="w-[100px]">
        <Tag label={tag.label} readonly={true} />
      </div>

      <Typography size="medium" variant="body" className="w-[125px]">
        {date}
      </Typography>
      <div className="w-[40px] flex items-center justify-center">
        {!selectionIndex ? null : (
          <div
            className={clsx(
              'w-4 h-4 rounded-lg text-xs flex justify-center items-center',
              sprinkles({ bg: 'P-20', color: 'N-80' }),
            )}
          >
            {selectionIndex}
          </div>
        )}
      </div>
    </div>
  );
};
